import React from 'react';
import UserDataOnDemand from 'UserData/Connector/Apollo/Fetch/UserDataOnDemandConnectorApollo';
import CouponRegisterComponent from './CouponRegisterComponent';
import RegisterConnector from './Connector/Apollo/Register/RegisterConnectorApollo';

class CouponRegisterContainer extends React.Component {
    render() {
        return (
            <RegisterConnector>
                {({ ...registerAndActivateCoupon }) => (
                    <UserDataOnDemand>
                        {({ ...userDataOnDemand }) => (
                            <CouponRegisterComponent
                                {...registerAndActivateCoupon}
                                {...userDataOnDemand}
                            />
                        )}
                    </UserDataOnDemand>
                )}
            </RegisterConnector>
        );
    }
}

export default CouponRegisterContainer;
